import React from "react";
import * as R from "ramda";

export const getTableConfig = (tab) => {
    return tab === "belum_assign" ? tableConfig.belumAssign : tableConfig.assigned;
}

const tableConfig = {
    belumAssign: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "kodeCabang",
            label: "Kode Cabang",
        },
        {
            name: "prospectDate",
            label: "Tanggal Prospek"
        },
        {
            name: "prospectId",
            label: "Nomor Prospek",
        },
        {
            name: "category",
            label: "Kategori Prospek",
        },
        {
            name: "type",
            label: "Jenis Prospek",
        },
        {
            name: "source",
            label: "Asal Prospek",
        },
        {
            name: "dataNotAssigned.name",
            label: "Nama",
        },
        {
            name: "dataNotAssigned.nik",
            label: "NIK",
        },
        {
            name: "dataNotAssigned.hpNumber1",
            label: "No HP 1",
        },
        {
            name: "dataNotAssigned.email",
            label: "Email",
        },
        {
            name: "dataNotAssigned.address",
            label: "Alamat",
        },
    ],
    assigned: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "kodeCabang",
            label: "Kode Cabang",
        },
        {
            name: "prospectDate",
            label: "Tanggal Prospek"
        },
        {
            name: "prospectId",
            label: "Nomor Prospek",
        },
        {
            name: "category",
            label: "Kategori Prospek",
        },
        {
            name: "type",
            label: "Jenis Prospek",
        },
        {
            name: "source",
            label: "Asal Prospek",
        },
        {
            name: "dataAssigned.sourceCabang",
            label: "Cabang Asal",
        },
        {
            name: "dataAssigned.lastSeller",
            label: "Penjual Terakhir",
        },
        {
            name: "dataAssigned.prospectOwnership",
            label: "Pemilik Prospek",
        },
        {
            name: "dataAssigned.followUpDate",
            label: "Last Follow Up Date",
        },
        {
            name: "dataAssigned.followUpStatus",
            label: "Last Follow Up Status",
        },
        {
            name: "dataAssigned.lastFollowUpBy",
            label: "Last Follow Up By",
        },
        {
            name: "dataAssigned.nextAppointmentDate",
            label: "Next Appointment Date",
        },
        {
            name: "dataAssigned.followUpResult",
            label: "Keterangan"
        }
    ],
}

export const defaultFilter = {
    prospectDate: {
        startDate: null,
        endDate: null,
    },
    followUpDate: {
        startLastDateFollowUp: null,
        endLastDateFollowUP: null,
    },
    appointmentDate: {
        startNextAppointment: null,
        endNextAppointment: null,
    },
    prospectCategory: null,
    prospectKind: null,
    prospectSource: null,
    idProvince: null,
    idKabkot: null,
    kecamatan: null,
    kelurahan: null,
    kodePos: null,
    memberLevel: null,
    loyaltyLevel: null,
    facebook: null,
    instagram: null,
    linkedin: null,
    x: null,
    tiktok: null,
    hobby: [],
    interest: [],
    prospectName: null,
    prospectId: null,
    memberId: null,
    sourceCabang: null,
    prospectOwnership: null,
    lastSeller: null,
    status: null,
    lastFollowUpBy: null,
    information: null,
    nama: null,
    nik: null,
    handPhoneNumber: null,
    handPhoneNumber2: null,
    alamat: null,
};

export const extractFilter = (body) => {
    return {
        startNextAppointment: !R.isNil(body?.appointmentDate?.startNextAppointment) ? body?.appointmentDate?.startNextAppointment : null,
        endNextAppointment: !R.isNil(body?.appointmentDate?.endNextAppointment) ? body?.appointmentDate?.endNextAppointment : null,
        startLastDateFollowUp: !R.isNil(body?.followUpDate?.startLastDateFollowUp) ? body?.followUpDate?.startLastDateFollowUp : null,
        endLastDateFollowUP: !R.isNil(body?.followUpDate?.endLastDateFollowUP) ? body?.followUpDate?.endLastDateFollowUP : null,
        startDate: !R.isNil(body?.prospectDate?.startDate) ? body?.prospectDate?.startDate : !R.isNil(body?.startDate) ? body?.startDate : null,
        endDate: !R.isNil(body?.prospectDate?.endDate) ? body?.prospectDate?.endDate : !R.isNil(body?.endDate) ? body?.endDate : null,
        prospectCategory: !R.isEmpty(body?.prospectCategory) ? body.prospectCategory?.value : null,
        prospectKind: !R.isEmpty(body?.prospectKind) ? body.prospectKind?.value : null,
        prospectSource: !R.isEmpty(body?.prospectSource) ? body.prospectSource?.value : null,
        idProvince: !R.isEmpty(body?.idProvince) ? body.idProvince?.value : null,
        idKabkot: !R.isEmpty(body?.idKabkot) ? body.idKabkot?.value : null,
        kecamatan: !R.isEmpty(body?.kecamatan) ? body.kecamatan?.value : null,
        kelurahan: !R.isEmpty(body?.kelurahan) ? body.kelurahan?.value : null,
        kodePos: !R.isEmpty(body?.kodePos) ? body.kodePos?.value : null,
        memberLevel: !R.isEmpty(body?.memberLevel) ? body.memberLevel?.value : null,
        loyaltyLevel: !R.isEmpty(body?.loyaltyLevel) ? body.loyaltyLevel?.value : null,
        facebook: !R.isEmpty(body?.facebook) ? body.facebook?.value : null,
        instagram: !R.isEmpty(body?.instagram) ? body.instagram?.value : null,
        linkedin: !R.isEmpty(body?.linkedin) ? body.linkedin?.value : null,
        x: !R.isEmpty(body?.x) ? body.x?.value : null,
        tiktok: !R.isEmpty(body?.tiktok) ? body.tiktok?.value : null,
        hobby: !R.isEmpty(body?.hobby) ? body?.hobby?.map(item => item.value) : null,
        interest: !R.isEmpty(body?.interest) ? body?.interest?.map(item => item.value) : null,
        kodeCabang: !R.isNil(body?.kodeCabang?.value) ? body.kodeCabang?.value : !R.isNil(body?.kodeCabang) ? body?.kodeCabang : null,
        memberId: !R.isNil(body?.memberId) ? body?.memberId : null,
        prospectName: !R.isNil(body?.prospectName) ? body.prospectName : null,
        sourceCabang: !R.isNil(body?.sourceCabang) ? body.sourceCabang : null,
        prospectOwnership: !R.isNil(body?.prospectOwnership) ? body.prospectOwnership : null,
        lastSeller: !R.isNil(body?.lastSeller) ? body.lastSeller : null,
        status: !R.isNil(body?.status) ? body.status : null,
        lastFollowUpBy: !R.isNil(body?.lastFollowUpBy) ? body.lastFollowUpBy : null,
        information: !R.isNil(body?.information) ? body.information : null,
        nama: !R.isNil(body?.nama) ? body.nama : null,
        nik: !R.isNil(body?.nik) ? body.nik : null,
        handPhoneNumber: !R.isNil(body?.handPhoneNumber) ? body.handPhoneNumber : null,
        handPhoneNumber2: !R.isNil(body?.handPhoneNumber2) ? body.handPhoneNumber2 : null,
        alamat: !R.isNil(body?.alamat) ? body.alamat : null,
    }
}

export const tableConfigListUser = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                const {page, rowsPerPage} = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                return <>{rowNumber}</>;
            },
        },
    },
    {
        name: "userName",
        label: "Username",
    },
    {
        name: "name",
        label: "Nama User",
    },
];